export default __webpack_public_path__ + "static/avenir-next-semi-bold-faa9921a92cd9042d439e9612649384b.woff";